(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentPlanning', {
        templateUrl: 'views/components/views/consignmentPlanning/consignmentPlanning.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'translateService', 'modalService', 'consignmentPlanningService', 'consignmentPlanService', 'orderHeadService', function (stateService, utilityService, translateService, modalService, consignmentPlanningService, consignmentPlanService, orderHeadService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let selectListDeliveryWeeksIndexed = {};

            let itemsListPlanning = {
                recordsIndexed: {},
                recordsBase: []
            };

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                stockPlaceButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('stockplace_id') }
                ],
                deliveryWeekButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('deliveryweek') }
                ],
                custactConsignmentPlanSelectedButtons: [
                    {
                        id: 'erase',
                        icon: 'fa fa-solid fa-eraser',
                        color: 'danger',
                        type: 'danger',
                        onClick: () => reset('custact_no_consignmentplan')
                    },
                    {
                        id: 'new',
                        icon: 'fa fa-solid fa-plus',
                        color: 'success',
                        type: 'success',
                        onClick: () => {
                            stateService.go('custactedit', {
                                custact_no: '0',
                                filterfield: 'cust_no',
                                filtervalue: vm.model.setting.businessco_cust_no
                            });
                        }
                    },
                    {
                        id: 'goto',
                        icon: 'fa fa-solid fa-chevron-right',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => {
                            stateService.go('subtasks', {
                                custact_no: vm.model.setting.custact_no_consignmentplan,
                                retrievetype: 'child',
                                include_top: '1'
                            });
                        }
                    }
                ],
                custactConsignmentPlanButtons: [
                    {
                        id: 'new',
                        icon: 'fa fa-solid fa-plus',
                        color: 'success',
                        type: 'success',
                        onClick: () => {
                            stateService.go('custactedit', {
                                custact_no: '0',
                                filterfield: 'cust_no',
                                filtervalue: vm.model.setting.businessco_cust_no
                            });
                        }
                    }
                ],
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.searchtext = '' }
                ],
                bgPlanningType: {
                    selected: 'status',
                    buttons: [
                        { id: 'status', label: 'consignmentplanning_gb1_status', color: 'primary', onClick: () => vm.model.bgPlanningType.selected = 'status' },
                        { id: 'planning', label: 'consignmentplanning_gb1_planning', color: 'primary', onClick: () => vm.model.bgPlanningType.selected = 'planning' },
                        { id: 'plans', label: 'consignmentplanning_gb1_plans', color: 'primary', onClick: () => vm.model.bgPlanningType.selected = 'plans' }
                    ]
                },
                bgPlanAction: {
                    selected: 'add',
                    buttons: [
                        { id: 'add', label: 'consignmentplanning_gb2_not_planned', color: 'primary', onClick: () => vm.model.bgPlanAction.selected = 'add' },
                        { id: 'planned', label: 'consignmentplanning_gb2_planned', color: 'primary', onClick: () => vm.model.bgPlanAction.selected = 'planned' }
                    ]
                },
                bgPlansStatus: {
                    selected: 'editplan',
                    buttons: [
                        { id: 'editplan', label: 'consignmentplanning_editplan', color: 'primary', onClick: () => vm.model.bgPlansStatus.selected = 'editplan' },
                        { id: 'statusplan', label: 'consignmentplanning_statusplan', color: 'primary', onClick: () => vm.model.bgPlansStatus.selected = 'statusplan' },
                        { id: 'sendplan', label: 'consignmentplanning_sendplan', color: 'primary', onClick: () => vm.model.bgPlansStatus.selected = 'sendplan' }
                    ]
                },
                bgPlanStatus: {
                    selected: 'ready',
                    buttons: [
                        { id: 'ready', label: 'consignmentplanning_ready', color: 'primary', onClick: () => vm.model.bgPlanStatus.selected = 'ready' },
                        { id: 'almost_ready', label: 'consignmentplanning_almost_ready', color: 'primary', onClick: () => vm.model.bgPlanStatus.selected = 'almost_ready' },
                        { id: 'not_ready', label: 'consignmentplanning_not_ready', color: 'primary', onClick: () => vm.model.bgPlanStatus.selected = 'not_ready' }
                    ]
                },
                setting: {
                    searchtext: ''
                },
                selectListStockPlaces: [],
                selectListDeliveryWeeks: [],
                selectListConsignmentPlans: [],
                selectListDeliveryMethods: [],
                itemsListPlanning: {
                    recordsReady: [],
                    recordsAlmostReady: [],
                    recordsNotReady: [],
                    recordsNotPlanned: [],
                    recordsPlanned: []
                },
                itemsListPlans: {
                    totalWeight: 0,
                    totalVolume: 0,
                    recordsBase: [],
                    recordsCopy: []
                },
                selected: {
                    count: 0,
                    totalVolume: 0,
                    totalWeight: 0
                },
                removable: {
                    count: 0,
                },
                lockedRemoveSelectedPlanning: false,
                lockedRemoveSelectedPlans: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await consignmentPlanningService.getSetting())[0];

                Promise.all([
                    loadConsignmentPlanning(),
                    loadDeliveryWeeks()
                ]).then(() => Promise.resolve());
            }

            async function loadStockPlaces() {
                vm.model.selectListStockPlaces = (await consignmentPlanService.listStockPlaces());
            }

            async function loadDeliveryMethods() {
                vm.model.selectListDeliveryMethods = (await consignmentPlanningService.listDeliveryMethods({ consignment_keyno: '0' }));
            }

            async function loadConsignmentPlans() {
                vm.model.selectListConsignmentPlans = (await consignmentPlanningService.listConsignmentPlans({ ok: '0' }));
            }

            async function loadDeliveryWeeks() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.deliverymethod_no) !== true) return;

                vm.model.selectListDeliveryWeeks = [];

                const selectListDeliveryWeeks = (await consignmentPlanningService.listDeliveryWeeks({
                    stockplace_id: vm.model.setting.stockplace_id,
                    deliverymethod_no: vm.model.setting.deliverymethod_no
                }));

                selectListDeliveryWeeks.forEach((item) => {
                    vm.model.selectListDeliveryWeeks.push(item);
                    selectListDeliveryWeeksIndexed[item.deliveryweek] = item;
                });
            }

            async function loadConsignmentPlanning() {
                if (vm.model.setting?.stockplace_id && vm.model.setting?.deliveryweek && vm.model.setting?.deliverymethod_no) {
                    let item = getCurrentDeliveryWeekListItem();

                    if (item?.date_fom && item?.date_tom) {
                        itemsListPlanning.recordsBase = [];

                        consignmentPlanningService.listConsignmentPlanning({
                            stockplace_id: vm.model.setting.stockplace_id,
                            date_fom: item.date_fom,
                            date_tom: item.date_tom,
                            custact_no_consignmentplan: vm.model.setting.custact_no_consignmentplan,
                            deliveryweek: vm.model.setting.deliveryweek,
                            deliverymethod_no: vm.model.setting.deliverymethod_no
                        }).then((list) => {
                            vm.model.itemsListPlanning.recordsReady = [];
                            vm.model.itemsListPlanning.recordsAlmostReady = [];
                            vm.model.itemsListPlanning.recordsNotReady = [];
                            vm.model.itemsListPlanning.recordsNotPlanned = [];
                            vm.model.itemsListPlanning.recordsPlanned = [];

                            itemsListPlanning.recordsIndexed = {};
                            itemsListPlanning.recordsBase = list;

                            refreshRecords();
                            onRecordsNotPlannedChanged();
                            onRecordsPlannedChanged();
                        });
                    } else {
                        clearRecords()
                    }
                }
            }

            function validateUpdateDrivingPlan() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.deliveryweek) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.deliverymethod_no) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.custact_no_consignmentplan) !== true) return;

                if (vm.model.bgPlanningType.selected === 'plans' && vm.model.setting.custact_no_consignmentplan > 0) {
                    if (vm.model.setting.deliverymethod_no === '') {
                        vm.model.setting.deliverymethod_no = '0';
                    }

                    vm.model.itemsListPlans.totalWeight = 0;
                    vm.model.itemsListPlans.totalVolume = 0;
                    vm.model.itemsListPlans.recordsBase = [];
                    vm.model.itemsListPlans.recordsCopy = [];

                    consignmentPlanningService.listConsignmentPlanning({
                        stockplace_id: vm.model.setting.stockplace_id,
                        date_fom: '',
                        date_tom: '',
                        custact_no_consignmentplan: vm.model.setting.custact_no_consignmentplan,
                        deliveryweek: vm.model.setting.deliveryweek,
                        deliverymethod_no: vm.model.setting.deliverymethod_no
                    }).then((response) => {
                        vm.model.itemsListPlans.recordsBase = response;
                        vm.model.itemsListPlans.recordsCopy = response;

                        vm.model.itemsListPlans.recordsCopy.forEach((item) => {
                            item.item_state = '';
                            item.item_parms = '';
                            item.item_path = '';
                        });

                        vm.model.itemsListPlans.recordsBase.forEach((item) => {
                            if (parseFloat(item.weight) >= 0) {
                                vm.model.itemsListPlans.totalWeight += parseFloat(item.weight);
                            }

                            if (parseFloat(item.volum) >= 0) {
                                vm.model.itemsListPlans.totalVolume += parseFloat(item.volum);
                            }
                        });
                    });
                }
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region OTHER FUNCTIONS

            function getCurrentDeliveryWeekListItem() {
                let out = false;

                if (vm.model?.selectListDeliveryWeeks && vm.model.selectListDeliveryWeeks.length > 0) {
                    if (vm.model.setting?.deliveryweek && vm.model.setting.deliveryweek > '') {
                        out = selectListDeliveryWeeksIndexed[vm.model.setting.deliveryweek];
                    }
                }

                return out;
            }

            function clearRecords() {
                vm.model.itemsListPlanning.recordsReady = [];
                vm.model.itemsListPlanning.recordsAlmostReady = [];
                vm.model.itemsListPlanning.recordsNotReady = [];
                vm.model.itemsListPlanning.recordsNotPlanned = [];
                vm.model.itemsListPlanning.recordsPlanned = [];

                onRecordsNotPlannedChanged();
                onRecordsPlannedChanged();
            }

            function refreshRecords() {
                vm.model.itemsListPlanning.recordsReady = [];
                vm.model.itemsListPlanning.recordsAlmostReady = [];
                vm.model.itemsListPlanning.recordsNotReady = [];
                vm.model.itemsListPlanning.recordsNotPlanned = [];
                vm.model.itemsListPlanning.recordsPlanned = [];
                itemsListPlanning.recordsIndexed = {};

                itemsListPlanning.recordsBase.forEach((item) => {
                    if (item.statusid === '1') {
                        vm.model.itemsListPlanning.recordsReady.push(item);
                    }

                    if (item.statusid === '2') {
                        vm.model.itemsListPlanning.recordsAlmostReady.push(item);
                    }

                    if (item.statusid === '3') {
                        vm.model.itemsListPlanning.recordsNotReady.push(item);
                    }

                    if (item.custact_no_consignmentplan === '0') {
                        vm.model.itemsListPlanning.recordsNotPlanned.push(item);
                    }

                    if (item.custact_no_consignmentplan !== '0') {
                        vm.model.itemsListPlanning.recordsPlanned.push(item);
                    }

                    itemsListPlanning.recordsIndexed[item.item_id] = item;
                });
            }

            function onRecordsNotPlannedChanged() {
                vm.model.selected.totalVolume = 0;
                vm.model.selected.totalWeight = 0;
                vm.model.selected.count = 0;

                vm.model.itemsListPlanning.recordsNotPlanned.forEach((item) => {
                    if (item.item_is_selected !== '0') {
                        vm.model.selected.count += 1;
                        var vol = parseFloat(item.volum);
                        var wei = parseFloat(item.weight);

                        if (vol >= 0) {
                            vm.model.selected.totalVolume += vol;
                        }

                        if (wei >= 0) {
                            vm.model.selected.totalWeight += wei;
                        }
                    }
                });
            }

            function onRecordsPlannedChanged() {
                vm.model.removable.count = 0;

                vm.model.itemsListPlanning.recordsPlanned.forEach((item) => {
                    if (item.item_is_selected !== '0') {
                        vm.model.removable.count += 1;
                    }
                });
            }

            // #endregion OTHER FUNCTIONS

            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'stockplace_id':
                        vm.model.setting.stockplace_id = 'ALL';

                        if (vm.model.setting.stockplace_id === 'ALL') {
                            loadDeliveryWeeks();
                            loadConsignmentPlanning();
                            validateUpdateDrivingPlan();
                        }
                        break;
                    case 'deliveryweek':
                        vm.model.setting.deliveryweek = 'All weeks';

                        if (vm.model.setting.deliveryweek === 'All weeks') {
                            loadConsignmentPlanning();
                            validateUpdateDrivingPlan();
                        }
                        break;
                    case 'custact_no_consignmentplan':
                        vm.model.setting.custact_no_consignmentplan = '0';

                        if (vm.model.setting.custact_no_consignmentplan === '0') {
                            if (vm.model.bgPlanningType.selected === 'planning') {
                                loadConsignmentPlanning();
                            } else if (vm.model.bgPlanningType.selected === 'plans') {
                                vm.model.itemsListPlans.totalVolume = 0;
                                vm.model.itemsListPlans.totalWeight = 0;
                                vm.model.itemsListPlans.recordsBase = [];
                                vm.model.itemsListPlans.recordsCopy = [];
                            }
                        }
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.addSelected = function () {
                vm.model.lockedAddSelected = true;
                let sendData = [];

                vm.model.itemsListPlanning.recordsNotPlanned.forEach((item) => {
                    if (item.item_is_selected === '1') {
                        sendData.push(item);
                        item.item_is_selected = '0';
                    }
                });

                consignmentPlanningService.addSelectedOrders({
                    custact_no_consignmentplan: vm.model.setting.custact_no_consignmentplan,
                    records: sendData
                }).then((response) => {
                    vm.model.lockedAddSelected = false;

                    response.forEach((item) => {
                        itemsListPlanning.recordsIndexed[item.order_internal_no].custact_no_consignmentplan = item.custact_no_consignmentplan;
                        itemsListPlanning.recordsIndexed[item.order_internal_no].item_is_selected = '0';
                        itemsListPlanning.recordsIndexed[item.order_internal_no].item_name_sub2 = item.item_name_sub2;
                    });

                    refreshRecords();
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.removePlanning = function () {
                vm.model.lockedRemoveSelectedPlanning = true;
                let sendData = [];

                vm.model.itemsListPlanning.recordsPlanned.forEach((item) => {
                    if (item.item_is_selected === '1') {
                        sendData.push(item);
                        item.item_is_selected = '1';
                    }
                });

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    consignmentPlanningService.removePlans({ records: sendData }).then((response) => {
                        vm.model.lockedRemoveSelectedPlanning = false;

                        response.forEach((item) => {
                            itemsListPlanning.recordsIndexed[item.order_internal_no].custact_no_consignmentplan = '0';
                            itemsListPlanning.recordsIndexed[item.order_internal_no].item_is_selected = '0';
                            itemsListPlanning.recordsIndexed[item.order_internal_no].item_name_sub2 = '';
                        });

                        refreshRecords();
                    }, () => {
                        vm.model.lockedRemoveSelectedPlanning = false;
                    });
                }, () => {
                    vm.model.lockedRemoveSelectedPlanning = false;
                });
            };

            vm.removeSelectedPlans = function () {
                vm.model.lockedRemoveSelectedPlans = true;
                let sendData = [];

                vm.model.itemsListPlans.recordsBase.forEach((item) => {
                    if (item.item_is_selected === '1') {
                        sendData.push(item);
                        item.item_is_selected = '1';
                    }
                });

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    consignmentPlanningService.removePlans({
                        volum: vm.model.itemsListPlans.totalVolume,
                        weight: vm.model.itemsListPlans.totalWeight,
                        records: sendData
                    }).then((response) => {
                        vm.model.lockedRemoveSelectedPlans = false;

                        response.forEach((item) => {
                            try {
                                if (itemsListPlanning.recordsIndexed[item.order_internal_no]) {
                                    itemsListPlanning.recordsIndexed[item.order_internal_no].custact_no_consignmentplan = '0';
                                    itemsListPlanning.recordsIndexed[item.order_internal_no].item_is_selected = '0';
                                    itemsListPlanning.recordsIndexed[item.order_internal_no].item_name_sub2 = '';
                                }
                            } catch (e) { }
                        });

                        refreshRecords();
                        validateUpdateDrivingPlan();
                    }, () => {
                        vm.model.lockedRemoveSelectedPlans = false;
                    });
                }, () => {
                    vm.model.lockedRemoveSelectedPlans = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region SCAN ITEM FUNCTION

            vm.scanItem = function (item) {
                orderHeadService.scanConsignment({ barcode: 'oi' + item.item_id }).then((response) => {
                    if (response[0]) {
                        stateService.go(response[0].webpagename, response[0].parms);
                    }
                });
            };

            // #endregion SCAN ITEM FUNCTION

            // #region MARK ITEM FUNCTION

            vm.markRecord = function (item) {
                onRecordsNotPlannedChanged();
                onRecordsPlannedChanged();
            };

            // #endregion MARK ITEM FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgPlanningType = function (value) {
                vm.model.bgPlanningType.selected = value;

                if (vm.model.bgPlanningType.selected === 'plans') validateUpdateDrivingPlan();
            };

            vm.selectBgPlanStatus = function (value) {
                vm.model.bgPlanStatus.selected = value;
            };

            vm.selectBgPlanAction = function (value) {
                vm.model.bgPlanAction.selected = value;
            };

            vm.selectBgPlansStatus = function (value) {
                vm.model.bgPlansStatus.selected = value;
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'stockplace_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

                        vm.model.setting.stockplace_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

                        loadDeliveryWeeks();
                        loadConsignmentPlanning();
                        validateUpdateDrivingPlan();
                        break;
                    case 'deliverymethod_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.deliverymethod_no) !== true) return;

                        vm.model.setting.deliverymethod_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.deliverymethod_no) !== true) return;

                        loadDeliveryWeeks();
                        loadConsignmentPlanning();
                        validateUpdateDrivingPlan();
                        break;
                    case 'deliveryweek':
                        if (utilityService.validateWatchValue(value, vm.model.setting.deliveryweek) !== true) return;

                        vm.model.setting.deliveryweek = value;

                        if (utilityService.validateParmsValue(vm.model.setting.deliveryweek) !== true) return;

                        loadConsignmentPlanning();
                        break;
                    case 'custact_no_consignmentplan':
                        if (utilityService.validateWatchValue(value, vm.model.setting.custact_no_consignmentplan) !== true) return;

                        vm.model.setting.custact_no_consignmentplan = value;

                        if (utilityService.validateParmsValue(vm.model.setting.custact_no_consignmentplan, true) !== true) return;

                        loadConsignmentPlanning();
                        validateUpdateDrivingPlan();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                loadStockPlaces();
                loadDeliveryMethods();
                await loadSetting();
                await loadConsignmentPlans();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
